import type { User } from "@mc/types"
import { apiRequest } from "./httpClient.js"

/** `GET /api/v1/users/lookup` (services/gateway/src/routes/users.ts): exact-match username lookup, used to turn a known username into a userId before inviting them to a server or family. */
export function lookupUserByUsername(username: string): Promise<{ user: User | null }> {
  return apiRequest(`/api/v1/users/lookup?username=${encodeURIComponent(username)}`)
}
